import type { Color } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { blue, blueGrey, green, red } from "@mui/material/colors";
import type { BackgroundJobStatus } from "@/api/background-job/_models/BackgroundJob";
import { toChipColourSx } from "@/app/chip.utils";

const LABELS: Record<BackgroundJobStatus, string> = {
  QUEUED: "Queued",
  RUNNING: "Running",
  DONE: "Done",
  FAILED: "Failed",
};

const HUES: Record<BackgroundJobStatus, Color> = {
  QUEUED: blueGrey,
  RUNNING: blue,
  DONE: green,
  FAILED: red,
};

interface JobStatusChipProps {
  status: BackgroundJobStatus;
}

/** A background job's status as a tinted chip (like the order and inventory status chips); a spinner while it's queued or running. */
export const JobStatusChip = (props: JobStatusChipProps) => {
  const { status } = props;
  const isRunning = status === "QUEUED" || status === "RUNNING";

  return (
    <Box
      sx={[
        toChipColourSx(HUES[status]),
        {
          alignItems: "center",
          borderRadius: 0.5,
          display: "inline-flex",
          fontSize: 12,
          fontWeight: 700,
          gap: 0.75,
          letterSpacing: "0.05em",
          lineHeight: "20px",
          px: 0.75,
          textTransform: "uppercase",
          verticalAlign: "middle",
          whiteSpace: "nowrap",
        },
      ]}
    >
      {isRunning && (
        <CircularProgress
          color="inherit"
          size={10}
          thickness={6}
        />
      )}
      {LABELS[status]}
    </Box>
  );
};
